import { memo } from "react";
import { SearchSingleFormModel } from "../../../../../model/searchInvoiceModels";
import { Button, Form, Input } from "antd";
import useQuery from "../../../../../helper/queryString";
const FormSearch: React.FC<{ searchClickCallBack: (formValues: SearchSingleFormModel) => void }> = ({ searchClickCallBack }) => {
    const query = useQuery();
    let formValuesInit: SearchSingleFormModel = {
        taxCode: query.get("masothue") ?? "",
        securityCode: query.get("sobaomat") ?? ""
    }
    const [form] = Form.useForm();
    return (<Form
        name="searchSingleInvoiceForm"
        initialValues={{ remember: true }}
        autoComplete="on"
        className=""
        form={form}
        onFinish={(values) => {
            searchClickCallBack({ taxCode: values.masothue, securityCode: values.sobaomat })
        }}
    >
        <Form.Item
            label="Mã số thuế"
            name="masothue"
            rules={[
                { required: true, message: "Vui lòng nhập mã số thuế" },
                {
                    validator(_, value) {
                        value = String(value).trim();
                        let patt = /^[0-9]{10}$/;
                        if (value.length > 10) {
                            patt = /^[0-9]{10}[-][0-9]{3}$/;
                        }
                        var number =
                            Number(value.charAt(0)) * 31 +
                            Number(value.charAt(1)) * 29 +
                            Number(value.charAt(2)) * 23 +
                            Number(value.charAt(3)) * 19 +
                            Number(value.charAt(4)) * 17 +
                            Number(value.charAt(5)) * 13 +
                            Number(value.charAt(6)) * 7 +
                            Number(value.charAt(7)) * 5 +
                            Number(value.charAt(8)) * 3;

                        let isValidTaxCode = patt.test(value) && (10 - (number % 11) == Number(value.charAt(9)));
                        if (isValidTaxCode) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error('Mã số thuế không hợp lệ'));
                    },
                }
            ]}
            className="form-label-message"
            initialValue={formValuesInit.taxCode}
        >
            <Input />
        </Form.Item>
        <Form.Item
            label="Số bảo mật"
            name="sobaomat"
            rules={[{ required: true, message: "Vui lòng nhập số bảo mật" }]}
            className="form-label-message"
            initialValue={formValuesInit.securityCode}
        >
            <Input />
        </Form.Item>
        <Form.Item>
            <Button type="primary" htmlType="submit">
                Tra cứu
            </Button>
        </Form.Item>
    </Form>)
}
export default memo(FormSearch)